export interface ICreateConsultationInvoicePayload {
  typeId: string;
  externalPaymentId?: string;
  locationId?: string;
  voucherCode?: string;
  mode?: InvoiceMode;
  blockId?: string;
  startTime?: string;
  endTime?: string;
  providerIds: string[];
  excludedProviderIds?: string[];
  preferredLanguages?: string[];
  attributes?: {
    createInvoice?: true;
    surchargeRate?: number;
    isInstant?: boolean;
  };
  locationCode?: string; //self
  consultationCode?: string; //self
  billingSource?: BillingSource;
  ignoreDuplicateConsultation?: boolean;
}

export enum BillingSource {
  PRACTO = 'practo',
  ALLO_INSTANT = 'allo_instant',
}

export enum InvoiceMode {
  Prepaid = 'prepaid',
  Postpaid = 'postpaid',
}

export enum Vendor {
  RAZORPAY = 'razorpay',
  EZETAP = 'ezetap',
  CASH = 'cash',
}

export interface ICreatePrescriptionInvoicePayload {
  voucherCode?: string;
  mode?: InvoiceMode;
  encounterId?: string;
  items?: {
    type: string;
    typeId: string;
    quantity: number;
  }[];
  showPseudoCoupon?: boolean;
  ignoreWhenNoItems?: boolean;
  attributes?: {
    includePaidItems?: boolean;
  };
  drugPreference?: IDrugFxPreference;
  labPreference?: ILabFxPreference;
  priceUnserviceable?: boolean;
  version: number;
}

export enum FxVenue {
  HOME = 'home',
  CLINIC = 'clinic',
}

export interface IDrugFxPreference {
  venues: FxVenue[];
  patientPreferredVenue: FxVenue;
  locationId?: string;
  addressId?: string;
  pincode?: string;
}

export interface ILabFxPreference {
  venues: FxVenue[];
  patientPreferredVenue: FxVenue;
  pincode?: string;
  locationId?: string;
  addressId?: string;
  collectionSlotId?: string;
  collectionDate?: string;
  collectionEndTime?: string;
  collectionStartTime?: string;
}

export interface IInventoryItemPurchase {
  vendor?: string;
  mode?: InvoiceMode;
  attributes?: {
    createInvoice: boolean;
  };
  voucherCode?: string;
  items?: {
    type: string;
    typeId: string;
    quantity: number;
  }[];
  locationId?: string;
}

export interface IRefundConsultationPayload {
  reason: string;
  patientId: string;
  consultationId: string;
}
